// Permission Center -- composite route guard (additive).
//
//   <PageAccessRoute pageKey="family.jobs.positions" infoSource={infoSource}
//                    guard={UserFamily} hasRoleAccess={() => Family()}>
//     <JobPositionsAdmin infoSource={infoSource} />
//   </PageAccessRoute>
//
//   * normal role access -> the EXISTING guard renders exactly as before;
//   * otherwise a valid individual permission (from the server, never under
//     Switch Role) -> the page renders; its API calls are re-checked by the
//     server, endpoint by endpoint;
//   * otherwise -> the existing guard runs and redirects as before.
// The existing guard component is never modified.
import React from "react";
import { isAuthenticated } from "./index";
import { hasPageGrant, canAccessElakayPage } from "../permissionCenter/pageAccess";
import { elakayAutoText as t } from "../pageInside/dataElakay";

// Shown above a page opened through an individual permission, so the user
// knows what the server will accept (the server enforces it anyway).
const GrantNotice = ({ infoSource, pageKey }) => {
  const canEdit = canAccessElakayPage({ infoSource, pageKey, action: "edit" });
  return (
    <div role="note" style={{ margin: "8px auto", maxWidth: 1180, padding: "10px 14px", borderRadius: 10, background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1e3a8a", fontSize: 14 }}>
      {canEdit
        ? t("h_perm_notice_edit", "You access this page through an individual permission. You can prepare and edit content; publication, status changes and deletion stay reserved to the Elakay team.")
        : t("h_perm_notice_view", "You access this page through an individual permission, in read-only mode.")}
    </div>
  );
};

const PageAccessRoute = ({ pageKey, infoSource, guard: Guard, guardProps = {}, hasRoleAccess, children }) => {
  const roleAccess = (() => {
    try { return Boolean(hasRoleAccess?.()); } catch { return false; }
  })();
  if (!roleAccess && isAuthenticated() && hasPageGrant(infoSource, pageKey)) {
    return <><GrantNotice infoSource={infoSource} pageKey={pageKey} />{children}</>;
  }
  return <Guard {...guardProps}>{children}</Guard>;
};

export default PageAccessRoute;
